import { render } from "./WalletChangePasswordModal.vue?vue&type=template&id=47c6abac&ts=true"
import script from "./WalletChangePasswordModal.vue?vue&type=script&lang=ts"
export * from "./WalletChangePasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__